// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2quwQ","radioRow":"SimpleQuestionBuilderModal_radioRow__pmOC2"};